import { usePrevious } from '@solinkcorp/solink-components';
import { trackLogin, trackLogout, trackRefreshSession } from 'core/analytics';
import { useEffect } from 'react';
import { type ImpersonatorSession, type LogoutHandler, type UserSession } from '../types';

/**
 * Hook to set up analytics and to track logins and logouts.
 * @param user - The current user session, if any.
 * @param impersonator - The current impersonator session, if any.
 * @param logoutHandlers - Mutable collection of logout handlers.
 */
export function useLoginAnalytics(
  user: UserSession | undefined,
  impersonator: ImpersonatorSession | undefined,
  logoutHandlers: { current: LogoutHandler }[],
): void {
  const prevUser = usePrevious(user);

  // Track logins and session refreshes.
  useEffect(() => {
    if (user && user.accessToken !== prevUser?.accessToken) {
      if (user.userId === prevUser?.userId) {
        trackRefreshSession(user, impersonator);
      } else {
        trackLogin(user, impersonator);
      }
    }
  }, [user, prevUser, impersonator]);

  // Track logouts.
  useEffect(() => {
    logoutHandlers.push({ current: trackLogout });
  }, [logoutHandlers]);
}
